<template>
    <div>
        <Breadcrumbs title="Welcome"/>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        mounted() {
            
        },
        methods: {
        },
    };
</script>